import React, { Fragment,useState,useEffect } from 'react'
import { Helmet } from 'react-helmet'
import {PageContainer,HomeLoaderContainer} from './theme'
import {default as LoadingCircles}  from '../components/Spinner'
import config from '../config/enviroment'
import { language } from '../utils/language'
import { useSelector } from 'react-redux'
import { RootState } from '../redux/reducers/index'

const Page = (props: any) => {
  const { title, children, favicon, loading, ...rest } = props
  const homeState: HomeStateType = useSelector((state: RootState) => state.home);

  const [animationEnd,setAnimationEnd] = useState(false);

  useEffect(()=>{
    if(!loading){
      setTimeout(()=>{
        setAnimationEnd(true)
      }, 3000);
    }
  },[loading])

  return (

    <PageContainer {...rest}>
      <Helmet>
        <title>{title ? title : `${language[homeState.default_language]["loading"]} ...`}</title>
        <link
          rel="apple-touch-icon"
          type={"image/png"}
          sizes={"32x32"}
          href={favicon ?  favicon : `${config.urlMultimedia}/vende/landing-img/favicon.svg`} 
        />
        <link
          rel="icon"
          type={"image/png"}
          sizes={"32x32"}
          href={favicon ?  favicon : `${config.urlMultimedia}/vende/landing-img/favicon.svg`} 
        />
        {/* <script  
        src={config.epaycoCheckout}
        >  
        </script> */}

      </Helmet>
        {(loading || !animationEnd) &&
          <HomeLoaderContainer ready={!loading}>
            <LoadingCircles showPowered={true}/>
          </HomeLoaderContainer>
          
        }
      
        {!loading &&
          <Fragment>{children}</Fragment>
        }      
    </PageContainer>
  )
}

export default Page